import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { FilingOption } from '@app/services/filing-options/types/filing-options';
import { Observable } from 'rxjs';
import { baseUri } from '@app/services/filing-options/constants/uri.constants';

@Injectable({
    providedIn: 'root',
})
export class FilingOptionsService {
    private readonly http = inject(HttpClient);

    getFilingOptionsByServiceTypeAndSupplier(serviceTypeId: string, supplierId: string): Observable<FilingOption[]> {
        return this.http.get<FilingOption[]>(baseUri, {
            params: {
                serviceTypeId,
                supplierId,
            },
        });
    }
}
